import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

import { ThemeSwitcher } from "./ThemeSwitcher";
import "uno.css";

const Home = lazy(async () => ({ default: (await import("./Home")).Home }));
const Room = lazy(async () => ({ default: (await import("./Room")).Room }));
const FullRoom = lazy(async () => ({ default: (await import("./FullRoom")).FullRoom }));
const Replay = lazy(async () => ({ default: (await import("./Replay")).Replay }));
const NotFound = lazy(async () => ({ default: (await import("./NotFound")).NotFound }));

export function App() {
  return (
    <>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/room/:uuid" element={<Room />} />
          <Route path="/full-room/:uuid" element={<FullRoom />} />
          <Route path="/replay/:uuid" element={<Replay />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <ThemeSwitcher />
    </>
  );
}
